module.exports = __webpack_public_path__ + "static/media/ekkiden-dark-blue.b95cd1df.png";